import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { BaseAppComponent, NotificationConfig } from '@r1-development/rps-shared-ui';
import { distinctUntilChanged, filter, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent extends BaseAppComponent implements OnInit {
  previousUrl: string = null;
  currentUrl: string = null;

  notificationsConfig: NotificationConfig = {
    enabled: true,
    showNotifications: true,
    showInQueue: true,
  };

  constructor(
    protected readonly activatedRoute: ActivatedRoute,
    private readonly auth: AuthService,
    protected readonly router: Router,
    protected readonly titleService: Title
  ) {
    super(activatedRoute, router, titleService);
  }

  ngOnInit(): void {
    this.setupAuth0UserListener();
    this.getPreviousURL();
  }

  getPreviousURL() {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
    });
  }

  /* load authorized user profile */
  private setupAuth0UserListener(): void {
    this.auth.user$.pipe(distinctUntilChanged(), filter(Boolean), takeUntil(this.destroyed$)).subscribe({
      next: () => {},
      error: (err) => {
        if ([401, 403].includes(err?.error?.status)) {
          this.router.navigate(['/access-denied']);
        }
      },
    });
  }
}
